import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=e1525fe8&scoped=true"
import script from "./MailDetail.vue?vue&type=script&lang=js"
export * from "./MailDetail.vue?vue&type=script&lang=js"
import style0 from "./MailDetail.vue?vue&type=style&index=0&id=e1525fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1525fe8",
  null
  
)

export default component.exports